import { Divider, ListItem, ListItemText } from '@mui/material'
import { Fragment } from 'react'

const InvoiceFromEmail = () => {
  return (
    <Fragment>
      <ListItem>
        <ListItemText>From: invoice@transpots.com</ListItemText>
      </ListItem>
      <Divider />
    </Fragment>
  )
}

export default InvoiceFromEmail
